import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-crecimiento',
  templateUrl: './crecimiento.component.html',
  styleUrls: ['./crecimiento.component.css']
})
export class CrecimientoComponent implements OnInit {

  constructor(public sanitizer: DomSanitizer) { }
  
  local:string;
  url:string;
  urlSafe: SafeResourceUrl;
  id_pais:string;
  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    if(this.id_pais=='593'){
    this.local=localStorage.getItem("nombreLocal").substring(0,3);
    this.url="http://62.171.172.148:8111/arbolArchivo/gestion.php?local=/ecuador/gestion/"+this.local;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }else{
      this.local=localStorage.getItem("nombreLocal").substring(0,4);
      this.url="http://62.171.172.148:8111/arbolArchivo/gestion.php?local=/panama/gestion/"+this.local;
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
     
    }
  }


 

}
